export const urlWithHighlight = (url: string) => {
  return withQuery(url, { highlight: 1 });
};

export const withQuery = (
  url: string,
  params: Record<string, string | number | boolean>,
) => {
  const u = new URL(url, window.location.origin); // 2nd argument is used if url is relative

  Object.entries(params).forEach(([key, value]) => {
    u.searchParams.set(key, String(value));
  });

  return u.toString();
};
